import { Order } from "@lemmonhq/types";
import { computed, defineComponent, ref } from "vue";
import { useMenu } from "../../providers";

import { formatPrice, getOrderDisplayName } from "@lemmonhq/orders";
import { useLocalization } from "@lemmonhq/uikit";

export const OrderReceipt = defineComponent<{ order: Order }>({
  name: "OrderReceipt",
  props: ["order"],
  setup(props) {
    const order = ref(props.order);
    const { shop, groupOrder } = useMenu();
    const { t } = useLocalization();
    const currency = computed(() => shop.value?.currency || "CHF");
    return () => {
      return (
        <div class="  p-0 ">
          <div class="text-center">
            {/* Order Details Card */}
            <div class="bg-base-200 rounded rounded-xl shadow-xl mb-8 border">
              <div class="p-3 lg:p-4">
                <div class="flex items-center justify-start gap-3 mb-4">
                  <h2 class="card-title text-2xl text-accent">
                    {t("customer.receipt.order_title", [
                      getOrderDisplayName(order.value),
                    ])}
                  </h2>
                </div>

                <div class="space-y-2 text-left">
                  <div>
                    <span class="text-sm text-base-content/60">
                      {t("customer.receipt.restaurant")}:
                    </span>
                    <span class="font-semibold ml-2">
                      {shop.value?.name || t("customer.receipt.restaurant")}
                    </span>
                  </div>
                  <div>
                    <span class="text-sm text-base-content/60">
                      {t("customer.receipt.service_method")}:
                    </span>
                    <span class="font-semibold capitalize ml-2">
                      {order.value?.service_method ||
                        t("customer.account.dine_in")}
                    </span>
                  </div>
                  {groupOrder.value?.table ? (
                    <div>
                      <span class="text-sm text-base-content/60">
                        {t("customer.receipt.table")}:
                      </span>
                      <span class="font-semibold ml-2">
                        {groupOrder.value?.table.name}
                      </span>
                    </div>
                  ) : null}
                  <div>
                    <span class="text-sm text-base-content/60">
                      {t("customer.receipt.status")}:
                    </span>
                    <span class="ml-2">
                      <span class="badge badge-success">
                        {order.value?.status || t("customer.receipt.confirmed")}
                      </span>
                    </span>
                  </div>
                </div>

                {order.value?.items && order.value.items.length > 0 && (
                  <div class="mt-6">
                    <div class="text-sm text-accent font-semibold mb-3 text-left">
                      {t("customer.receipt.order_items")}:
                    </div>
                    <div class="space-y-2">
                      {order.value.items.map((item, index) => (
                        <div
                          key={index}
                          class="flex justify-between items-center p-0 bg-base-200 rounded"
                        >
                          <div class="flex items-center justify-start gap-4">
                            <span class="badge badge-outline badge-sm self-start m-1">
                              {item.quantity}x
                            </span>
                            <span class="text-sm text-left self-start">
                              {item.product?.name || t("customer.receipt.item")}
                            </span>
                          </div>
                          <span class="text-xs font-semibold text-right w-24">
                            {formatPrice(item.price, true, 2, currency.value)}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    };
  },
});
